<template>
  <div class="subscribers">
    <v-user-create-update-form v-if="this.isShowModal" @close="closeModal" />
    <div class="row pb-3">
      <div class="col-lg-8">
        <h5>Всего: {{ userList.count }}</h5>
      </div>
      <div class="col-lg-4 text-center">
        <button class="btn-primary" @click="showModal">Добавить подписчика</button>
      </div>
    </div>
    <div v-if="this.loading" class="col-lg-9">
      <div class="d-flex justify-content-center">
        <div class="spinner-grow m-5" role="status">
          <span class="sr-only">Loading...</span>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="row">
        <div class="col-3">
          <div class="form-group">
            <label for="search">Поиск по фамилии</label>
            <input class="form-control" id="search" v-model="searchText"
                      @input="getFilteredUserList()"
                      @focusin="InputFocusIn('search')"
                      @focusout="InputFocusOut('search')"/>
          </div>
        </div>
        <div class="col-3">
          <div class="form-group">
            <label for="search-phone">Поиск по телефону</label>
            <input class="form-control" id="search-phone" v-model="searchPhone"
                      @input="getFilteredUserList()"
                      @focusin="InputFocusIn('search-phone')"
                      @focusout="InputFocusOut('search-phone')"/>
          </div>
        </div>
        <div class="col-3 text-center pt-3">
           <input
              type="checkbox" class="form-check-input"
              @change="getFilteredUserList()"
              id="is-active" v-model="isActive">
            <label class="pl-3 form-check-label" for="is-active">
              только активные
            </label>
        </div>
        <div class="col-3 text-center pt-3">
          <input
              type="checkbox" class="form-check-input"
              @change="getFilteredUserList()"
              id="with-balance" v-model="withBalance">
            <label class="pl-3 form-check-label" for="with-balance">
              только с балансом
            </label>
        </div>
      </div>
      <v-user-table :user-list="this.userList" :role="userData.role"
                    @update="closeModal" @close="closeModal" />
      <nav class="border pt-3" aria-label="navigation">
        <paginate
          :page-count="this.userList.total_pages"
          :click-handler="clickCallback"
          :prev-text="'Назад'"
          :next-text="'Вперед'"
          :container-class="'pagination justify-content-center'"
          :page-class="'page-item'"
          :page-link-class="'page-link'"
          :prev-class="'page-item'"
          :prev-link-class="'page-link'"
          :next-class="'page-item'"
          :next-link-class="'page-link'">
        </paginate>
      </nav>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import VUserTable from '../../components/tables/v-user-table.vue';
import VUserCreateUpdateForm from '../../components/forms/v-user-create-update-form.vue';

export default {
  name: 'Subscribers',
  components: { VUserCreateUpdateForm, VUserTable },
  computed: {
    ...mapState('user', ['userList']),
    ...mapState('user', ['userData']),
  },
  data() {
    return {
      searchText: '',
      searchPhone: '',
      isActive: '',
      withBalance: '',
      isShowModal: false,
      loading: true,
      fullFilter: '',
      page: 1,
    };
  },
  methods: {
    ...mapActions('user', ['getUserList']),
    clickCallback(pageNum) {
      this.page = pageNum;
      this.getFilteredUserList();
    },
    getFilteredUserList() {
      this.fullFilter = `?page=${this.page}&role=subscriber`;
      if (this.searchText) {
        this.fullFilter += `&last_name=${this.searchText}`;
      }
      if (this.searchPhone) {
        this.fullFilter += `&contact_phone=${this.searchPhone}`;
      }
      if (this.isActive) {
        this.fullFilter += '&is_active=true';
      }
      if (this.withBalance) {
        this.fullFilter += '&with_balance=true';
      }
      this.getUserList(this.fullFilter)
        .then(() => { this.loading = false; });
    },
    closeModal() {
      this.isShowModal = false;
      this.loading = true;
      this.getFilteredUserList('');
    },
    showModal() {
      this.isShowModal = true;
    },
  },
  mounted() {
    this.getFilteredUserList();
  },
};
</script>
